import BookmarkIcon from '@mui/icons-material/Bookmark';

export default BookmarkIcon;
